import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { RootStore } from '../../../redux/store'
import { SelectOption } from '../../../services/dashboardService'
import { extractEmployees } from '../utils/utils'
import { ManagerBookingOptions } from '../consts'

interface UseBookingForProps {
  bookingFor: number
  selectedEmployee?: SelectOption
  isManager: boolean
}

interface UseBookingForReturn {
  employees: SelectOption[]
  isManagerBookingForEmployeeWithoutSelection: boolean
}

export const useBookingFor = ({
    bookingFor,
    selectedEmployee,
    isManager
}: UseBookingForProps): UseBookingForReturn => {
    const { directReports } = useSelector((state: RootStore) => state.appSettings)
    const employees = useMemo(() => extractEmployees(directReports), [directReports])

    // Check if manager selected "Employee" but hasn't selected a specific employee
    const isManagerBookingForEmployeeWithoutSelection =
        isManager &&
        bookingFor === ManagerBookingOptions.EMPLOYEE &&
        (!selectedEmployee || !selectedEmployee?.displayValue?.length)

    return {
        employees,
        isManagerBookingForEmployeeWithoutSelection
    }
}
